import React, { useState } from "react";
import { PrimaryButton } from "Components/Button";
import { Checkbox, Input, Label, Select } from "Components/Form";
//import { CountryDropdown } from "react-country-region-selector";
import { User } from "Services";
import BooleanSelect from "Components/Form/BooleanSelect";
import { Container } from "Components/Utilities";

import MeApi from 'Services/Api/Me/Me';
import MailLink from "Components/Utilities/MailLink";
import {getFallbackAvatarUrl} from 'Services/AuthHelpers';
import { FileUpload } from "Components/Form";
import CountrySelect from "Components/Form/CountrySelect";

const marketUnits = ['APAC', 'BGIUK', 'ELA', 'KSA', 'Group'];
//const regions = ['Europe', 'North America', 'South America', 'Africa', 'Asia', 'Australasia'];
const businessUnits = {
    'APAC': ['APAC', 'Bupa Health Insurance Australia', 'Bupa Health Services Australia', 'Bupa Villages & Aged Care Australia', 'Bupa Villages & Aged Care New Zealand', 'Bupa Hong Kong', 'Quality HealthCare'],
    'BGIUK': ['BGIUK', 'UK Insurance', 'Bupa Dental Care', 'Health Services', 'Care Services', 'Bupa Global', 'Niva Bupa'],
    'ELA': ['ELA', 'Sanitas Seguros', 'Sanitas Hospitales', 'Sanitas Dental', 'Sanitas Mayores', 'Bupa Chile', 'LUX MED', 'Bupa Turkiye', 'Bupa Global Latin America', 'Bupa Mexico', 'Care Plus'],
    'KSA': ['Bupa Arabia', 'My Clinic'],
    'Group': ['Group functions']
};
const dietaryOptions = [
    'None',
    'Vegetarian',
    'Vegan',
    'Halal',
    'Kosher',
    'Gluten Free',
    'Dairy Free',
    'Nut Allergy',
    'Shellfish Allergy',
    'Other'
];

const RegistrationForm = ({ form, onSubmit, onSuccess, isPastDeadline, isAdmin=false,  ...props }) => {
    const { working, handleSubmit, getFieldError, handleInput } = props;
    const [step, setStep] = useState(1); // Add a state variable for the current step

    const deadline = new Date('2026-09-30'); // Set your deadline date here
    const currentDate = new Date();

    // const goToStep2 = () => {
    //     //if the email address contains bupa.com, set the group to internal
    //     if (form.email.includes('bupa.com')) {
    //         if (currentDate > deadline) {
    //             form.group =  'Internal Virtual';
    //         } else {
    //             console.log('setting group to internal');
    //             form.group =  'Internal';
    //         }
    //     } else {
    //         if (currentDate > deadline) {
    //             form.group =  'External Virtual';
    //         } else {
    //             form.group =  'External';
    //         }
    //     }
    //     setStep(2);
    // };

    const [errorMessage, setErrorMessage] = useState(null);
    const [errorMessageInteral, setErrorMessageInternal] = useState(null);

    const lookup = async (form) => {
        setErrorMessage(null);
        setErrorMessageInternal(null);
        const response = await MeApi.registrationLookup(form);
        if (response.status === 300) {
            if (response.error){
                setErrorMessage ( true );
            }

            if (response.error_internal) {
                setErrorMessageInternal ( true );
            }
        }
        return response;
    };
    const onType = ({ type }) => {
        handleInput('group', type);
        setStep(2);
    };

    const handleFormSubmit = async (e) => {
        if (step === 1) {
            await handleInput('is_attending', true);
            const response = await handleSubmit(e, lookup, onType);

            // Check if the errorMessage state has been set
            if (errorMessage || errorMessageInteral) {
                setStep(1);
                return;
            }

            return response;
        }

        return handleSubmit(e, onSubmit, () => onSuccess(form.is_attending === true, form.group));
    };

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const isVirtual = form.group?.indexOf('virtual') !== -1;

    return (
        <div>
            { form.is_attending !== null && form.group && (
                <div className="bg-app-darker-blue py-10 lg:py-20">
                    <Container>
                        <div className="space-y-6 text-xl text-app-blue text-center">
                            <div className="text-3xl text-app-blue font-bold">
                                We’re really pleased you are able to join us { isVirtual ? <span className={"font-bold"}> virtually </span> : "" } on Wednesday 15 October 2025.
                            </div>

                            <p>
                                Please complete your details below so we can register your { isVirtual ? <span className={"font-bold"}> virtual  </span> : "" } attendance.
                            </p>

                            {!isVirtual && (
                                <p>
                                    Please note registration will close on 2nd October.
                                </p>
                            )}
                        </div>
                    </Container>
                </div>
            ) }

            <div className="py-10">
                <form
                    onSubmit={ handleFormSubmit }
                    className="space-y-6 max-w-2xl mx-auto px-4"
                >
                    { step === 1 ? (
                        <>
                            <Input
                                onChange={ (v) => handleInput(`email`, v) }
                                type="email"
                                value={ form?.email }
                                label="Email Address"
                                error={ getFieldError(`email`) }
                                required
                                labelColour={ 'text-app-blue' }
                            />
                            <div className={ "w-full mx-auto flex justify-center gap-5" }>
                                { ( !errorMessage && !errorMessageInteral ) && (!isPastDeadline || isAdmin) && (
                                    <PrimaryButton
                                        onClick={async (e) => {
                                            await handleInput('is_attending', true);
                                            handleSubmit(e, lookup, onType);
                                        } }
                                        text={ "I can attend" }
                                        disabled={ !emailRegex.test(form?.email) }
                                        working={working}
                                    />
                                ) }
                                <PrimaryButton
                                    onClick={async (e) => {
                                        await handleInput('is_attending', false);

                                        handleSubmit(e, lookup, onType);
                                    }}
                                    text={ "I can attend virtually" }
                                    disabled={ !emailRegex.test(form?.email) }
                                    working={working}
                                />
                            </div>
                        </>
                    ) : (
                        <>
                            { ( !errorMessage && !errorMessageInteral ) && (
                                <>
                                    <div className="flex justify-center">
                                        <PrimaryButton
                                            text="Back"
                                            working={ working }
                                            onClick={ () => setStep ( 1 ) }
                                        />
                                    </div>

                                    {
                                        // Use a switch statement to load the correct form based on the group
                                        ( () => {
                                            switch ( form.group ) {
                                                case 'internal':
                                                    return <InternalForm form={ form } { ...props } />;
                                                case 'internal-virtual':
                                                    return <InternalVirtualForm form={ form } { ...props } />;
                                                case 'external':
                                                    return <ExternalForm form={ form } { ...props } />;
                                                case 'external-virtual':
                                                    return <ExternalVirtualForm form={ form } { ...props } />;
                                                default:
                                                    return <CommonFields form={ form } { ...props } />;
                                            }
                                        } ) ()
                                    }
                                    <div className="flex justify-center">
                                        <PrimaryButton
                                            text="Save"
                                            working={ working }
                                        />
                                    </div>
                                </>
                            ) }

                            { errorMessage && (
                                <div className={ "w-full mx-auto flex justify-center gap-5 space-y-10 flex-col" }>
                                    <p className="text-app-blue text-center font-bold">
                                        Thank you for your interest in the Bupa Symposium 2025 event.
                                    </p>
                                    <p className="text-app-blue text-center">
                                        Unfortunately, we've reached our in-person capacity, but we'd love to have you
                                        join us virtually. Please register virtually below and watch the event online.
                                    </p>
                                    <p className="text-app-blue text-center">
                                        If you have any questions, please contact <MailLink
                                        to={ "healthcaresymposium@bupa.com" }
                                        className={ "underline" }
                                    />
                                    </p>
                                    <div className={"max-w-40 mx-auto"}>
                                        <PrimaryButton
                                            onClick={async (e) => {
                                                await handleInput('is_attending', false);
                                                handleSubmit(e, lookup, onType);
                                            }}
                                            text={ "I can attend virtually" }
                                            disabled={ !emailRegex.test(form?.email) }
                                            working={working}
                                        />
                                    </div>
                                </div>
                            )}

                            { errorMessageInteral && (
                                <div className={ "w-full mx-auto flex justify-center gap-5 space-y-10 flex-col" }>
                                    <p className="text-app-blue text-center font-bold">
                                        Thank you for your interest in the Bupa Symposium 2025 event.
                                    </p>
                                    <p className="text-app-blue text-center">
                                        We currently have limited spaces for internal
                                        guests however we'd love for you to join us virtually on Wednesday
                                        15th October 2025.
                                        Please complete your details below so we can register your virtual attendance.

                                        {!isVirtual && (
                                            <>
                                                Please note registration will close on 2nd October.
                                            </>
                                        )}
                                    </p>
                                    <p className="text-app-blue text-center">
                                        If you have any questions, please contact <MailLink
                                        to={ "healthcaresymposium@bupa.com" }
                                        className={ "underline" }
                                    />
                                    </p>
                                    <div className={"max-w-40 mx-auto"}>
                                        <PrimaryButton
                                            onClick={async (e) => {
                                                await handleInput('is_attending', false);
                                                handleSubmit(e, lookup, onType);
                                            }}
                                            text={ "I can attend virtually" }
                                            disabled={ !emailRegex.test(form?.email) }
                                            working={working}
                                        />
                                    </div>
                                </div>
                            )}
                        </>
                    ) }
                </form>
            </div>
        </div>
    );
};

const CommonFields = ({ form, getFieldError, handleInput, ...props }) => {
    return (
        <>
            <Input
                onChange={ (v) => handleInput(`first_name`, v) }
                value={ form?.first_name }
                label="First Name*"
                error={ getFieldError(`first_name`) }
                required
                labelColour={ 'text-app-blue' }
            />
            <Input
                onChange={ (v) => handleInput(`last_name`, v) }
                value={ form?.last_name }
                label="Last Name*"
                error={ getFieldError(`last_name`) }
                required
                labelColour={ 'text-app-blue' }
            />
            <Input
                onChange={ (v) => handleInput(`email`, v) }
                type="email"
                value={ form?.email }
                label={`${form.group?.indexOf('internal') !== -1 ? 'Bupa ' : ''}Email Address`}
                error={ getFieldError(`email`) }
                required
                labelColour={ 'text-app-blue' }
            />
            <Input
                onChange={ (v) => handleInput(`job_title`, v) }
                value={ form?.job_title }
                label="Job Title*"
                error={ getFieldError(`job_title`) }
                required
                labelColour={ 'text-app-blue' }
            />
            <Input
                onChange={ (v) => handleInput(`linkedin`, v) }
                value={ form?.linkedin }
                label="Please enter your LinkedIn handle (this will help with your networking profile)"
                error={ getFieldError(`linkedin`) }
                labelColour={ 'text-app-blue' }
            />
            <CountrySelect
                value={ form?.country ?? null }
                onChange={ ( v ) => handleInput ( `country`, v ) }
                classes={ `w-full p-2 border border-app-blue rounded` }
                label="Country*"
                error={ getFieldError ( `country` ) }
            />
            <div className={"my-10 space-x-6"}>
                <Label label={"Profile Image"} htmlFor={"avatar_path"} className={ "text-app-blue" } />

                {getFieldError ( `avatar_path` ) && (
                    <p className="text-red-500 text-sm">{getFieldError ( `avatar_path` )}</p>
                )}

                <FileUpload
                    containerClassName="m-8 mt-4 flex flex-col justify-center items-center gap-4"
                    value={ form.avatar_path }
                    onChange={ v => handleInput ( 'avatar_path', v ) }
                    accept="image/*"
                    placeholder="Please upload a profile image (This will help with your networking profile )"
                    fallbackImage={ getFallbackAvatarUrl ( form ) }
                    error={ getFieldError ( `avatar_path` ) }
                />
            </div>

            <Input
                labelColour={ "text-app-blue" }
                label={"The Symposium will be presented in English, if you are not fluent in English what would be your preferred language?"}
                placeholder="Preferred Language"
                value={ form?.preferred_language }
                id="preferred_language"
                error={ getFieldError ( 'preferred_language' ) }
                onChange={ ( v ) => handleInput ( 'preferred_language', v ) }
                containerClassName={ "col-span-2 md:col-span-1" }
            />
        </>
    );
};

const InternalForm = ({ form, getFieldError, handleInput, ...props }) => {

    let bu = [];

    if (form && form.market_unit && businessUnits[form.market_unit]) {
        bu = businessUnits[form.market_unit];
    }

    const group = User?.data?.groups.length > 0 ? User?.data?.groups[0].name?.toLowerCase() : 'internal';

    return (
        <div>

            <CommonFields
                form={ form }
                getFieldError={ getFieldError }
                handleInput={ handleInput } { ...props } />

            <Select
                label="Market Unit*"
                options={ marketUnits.map ( ( unit ) => ( { value: unit, label: unit } ) ) }
                value={ form?.market_unit ?? null }
                onChange={ ( v ) => handleInput ( `market_unit`, v ) }
                error={ getFieldError ( `market_unit` ) }
                //add border app-blue
                className={ 'border-app-blue' }
            />

            { bu.length > 0 &&
                <Select
                    label="Business Unit"
                    options={ bu.map ( ( unit ) => ( { value: unit, label: unit } ) ) }
                    value={ form?.business_unit ?? null }
                    onChange={ ( v ) => handleInput ( `business_unit`, v ) }
                    error={ getFieldError ( `business_unit` ) }
                />
            }

            {/*<Select*/}
            {/*    label="Country"*/}
            {/*    options={ regions.map ( ( unit ) => ( { value: unit, label: unit } ) ) }*/}
            {/*    value={ form?.region ?? null }*/}
            {/*    onChange={ ( v ) => handleInput ( `region`, v ) }*/}
            {/*    error={ getFieldError ( `region` ) }*/}
            {/*/>*/}

            <Select
                label="Dietary Requirements"
                options={ dietaryOptions.map ( ( option ) => ( { value: option, label: option } ) ) }
                value={ form?.dietary_requirements ?? null }
                onChange={ ( v ) => handleInput ( `dietary_requirements`, v ) }
                error={ getFieldError ( `dietary_requirements` ) }
            />

            { form?.dietary_requirements === 'Other' && (
                <Input
                    onChange={ ( v ) => handleInput ( `dietary_requirements_other`, v ) }
                    value={ form?.dietary_requirements_other }
                    label="Please specify"
                    error={ getFieldError ( `dietary_requirements_other` ) }
                    labelColour={ 'text-app-blue' }
                />
            ) }

            <Input
                onChange={ ( v ) => handleInput ( `special_access_requirements`, v ) }
                value={ form?.special_access_requirements ?? null }
                label="Please detail any accessibility requirements"
                error={ getFieldError ( `special_access_requirements` ) }
                labelColour={ 'text-app-blue' }
            />

            <BooleanSelect
                label="The Bupa Symposium virtual platform offers the opportunity for you to connect with other attendees. Please choose 'No' below if you want your contact information omitted from the platform."
                value={ form?.consent_networking ?? null }
                onChange={ ( v ) => handleInput ( `consent_networking`, v ) }
                error={ getFieldError ( `consent_networking` ) }
            />

            <Input
                onChange={ ( v ) => handleInput ( `password`, v ) }
                value={ form?.password ?? null }
                label="Please enter a password for this website – passwords should be 10 characters long and contain at least one number and one uppercase letter*"
                error={ getFieldError ( `password` ) }
                type="password"
                labelColour={ 'text-app-blue' }
            />

            <Input
                onChange={ ( v ) => handleInput ( `password_confirmation`, v ) }
                value={ form?.password_confirmation ?? null }
                label="Confirm Password*"
                error={ getFieldError ( `password_confirmation` ) }
                type="password"
                labelColour={ 'text-app-blue' }
            />

            <p className="text-app-blue">
                By registering to attend this event in person, you confirm your consent to be featured in event photography/videography.
            </p>
        </div>
    );
};

const InternalVirtualForm = ( { form, getFieldError, handleInput, ...props } ) => {
    let bu = businessUnits?.[ form?.market_unit ] ?? [];

    return (
        <>
            <CommonFields form={form} getFieldError={getFieldError} handleInput={handleInput} {...props} />

            <Select
                label="Market Unit*"
                options={marketUnits.map((unit) => ({ value: unit, label: unit }))}
                value={form?.market_unit ?? null}
                onChange={(v) => handleInput(`market_unit`, v)}
                error={getFieldError(`market_unit`)}
                required
            />

            {bu.length > 0 &&
                <Select
                    label="Business Unit"
                    options={bu.map((unit) => ({ value: unit, label: unit }))}
                    value={form?.business_unit ?? null}
                    onChange={(v) => handleInput(`business_unit`, v)}
                    error={getFieldError(`business_unit`)}
                    required
                />
            }

            {/*<Select*/}
            {/*    label="Region"*/}
            {/*    options={regions.map((unit) => ({ value: unit, label: unit }))}*/}
            {/*    value={form?.region ?? null}*/}
            {/*    onChange={(v) => handleInput(`region`, v)}*/}
            {/*    error={getFieldError(`region`)}*/}
            {/*/>*/}

            <Input
                onChange={ (v) => handleInput(`password`, v) }
                value={ form?.password ?? null }
                label="Please enter a password for this website – passwords should be 10 characters long and contain at least one number and one uppercase letter*"
                error={ getFieldError(`password`) }
                type="password"
                labelColour={ 'text-app-blue' }
            />

            <Input
                onChange={ (v) => handleInput(`password_confirmation`, v) }
                value={ form?.password_confirmation ?? null }
                label="Confirm Password*"
                error={ getFieldError(`password_confirmation`) }
                type="password"
                labelColour={ 'text-app-blue' }
            />
        </>
    );
};

const ExternalForm = ({ form, getFieldError, handleInput, ...props }) => {

    const organizationTypes = [
        'Public healthcare',
        'Private healthcare',
        'Financial services',
        'Technology services',
        'Consulting services',
        'Government',
        'Healthcare regulation',
        'Not-for-profit healthcare organisation and/or charity',
        'Media services',
        'Other'
    ];

    return (
        <>
            <CommonFields
                form={ form }
                getFieldError={ getFieldError }
                handleInput={ handleInput }
            />

            <Input
                onChange={ ( v ) => handleInput ( `company_name`, v ) }
                value={ form?.company_name }
                label="Company Name*"
                error={ getFieldError ( `company_name` ) }
                labelColour={ 'text-app-blue' }
            />

            <Select
                label="Which best describes the type of organisation you work for?*"
                options={ organizationTypes.map ( ( type ) => ( { value: type, label: type } ) ) }
                value={ form?.organization_type ?? null }
                onChange={ ( v ) => handleInput ( `organization_type`, v ) }
                error={ getFieldError ( `organization_type` ) }
            />

            { form?.organization_type === 'Other' && (
                <Input
                    onChange={ ( v ) => handleInput ( `organization_type_other`, v ) }
                    value={ form?.organization_type_other }
                    label="Please specify"
                    error={ getFieldError ( `organization_type_other` ) }
                    labelColour={ 'text-app-blue' }
                />
            ) }

            <Select
                label="Dietary Requirements"
                options={ dietaryOptions.map ( ( option ) => ( { value: option, label: option } ) ) }
                value={ form?.dietary_requirements ?? null }
                onChange={ ( v ) => handleInput ( `dietary_requirements`, v ) }
                error={ getFieldError ( `dietary_requirements` ) }
            />

            { form?.dietary_requirements === 'Other' && (
                <Input
                    onChange={ ( v ) => handleInput ( `dietary_requirements_other`, v ) }
                    value={ form?.dietary_requirements_other }
                    label="Please specify"
                    error={ getFieldError ( `dietary_requirements_other` ) }
                    labelColour={ 'text-app-blue' }
                />
            ) }

            <Input
                onChange={ ( v ) => handleInput ( `special_access_requirements`, v ) }
                value={ form?.special_access_requirements ?? null }
                label="Please detail any accessibility requirements"
                error={ getFieldError ( `special_access_requirements` ) }
                labelColour={ 'text-app-blue' }
            />

            <BooleanSelect
                label="The Bupa Symposium virtual platform offers the opportunity for you to connect with other attendees. Please choose 'No' below if you want your contact information omitted from the platform.*"
                value={ form?.consent_networking ?? null }
                onChange={ ( v ) => handleInput ( `consent_networking`, v ) }
                error={ getFieldError ( `consent_networking` ) }
            />

            <Input
                onChange={ ( v ) => handleInput ( `password`, v ) }
                value={ form?.password ?? null }
                label="Please enter a password for this website – passwords should be 10 characters long and contain at least one number and one uppercase letter*"
                error={ getFieldError ( `password` ) }
                type="password"
                labelColour={ 'text-app-blue' }
            />

            <Input
                onChange={ ( v ) => handleInput ( `password_confirmation`, v ) }
                value={ form?.password_confirmation ?? null }
                label="Confirm Password*"
                error={ getFieldError ( `password_confirmation` ) }
                type="password"
                labelColour={ 'text-app-blue' }
            />

            <p>
                By registering to attend this event in person, you confirm your consent to be featured in event photography/videography.
            </p>

        </>
    );
};

const ExternalVirtualForm = ( { form, getFieldError, handleInput, ...props } ) => {

    const organizationTypes = [
        'Public healthcare',
        'Private healthcare',
        'Financial services',
        'Technology services',
        'Consulting services',
        'Government',
        'Healthcare regulation',
        'Not-for-profit healthcare organisation and/or charity',
        'Media services',
        'Other'
    ];

    return (
        <>
            <CommonFields form={form} getFieldError={getFieldError} handleInput={handleInput} {...props} />

            <Input
                onChange={(v) => handleInput(`company_name`, v)}
                value={form?.company_name}
                label="Company Name"
                error={getFieldError(`company_name`)}
                labelColour={ 'text-app-blue' }
            />

            <Select
                label="Which best describes the type of organisation you work for?"
                options={organizationTypes.map((type) => ({ value: type, label: type }))}
                value={form?.organization_type ?? null}
                onChange={(v) => handleInput(`organization_type`, v)}
                error={getFieldError(`organization_type`)}
            />


            {form?.organization_type === 'Other' && (
                <Input
                    onChange={(v) => handleInput(`organization_type_other`, v)}
                    value={form?.organization_type_other}
                    label="Please specify"
                    error={getFieldError(`organization_type_other`)}
                    labelColour={ 'text-app-blue' }
                />
            )}

            {/*<Select*/}
            {/*    label="Region"*/}
            {/*    options={regions.map((unit) => ({ value: unit, label: unit }))}*/}
            {/*    value={form?.region ?? null}*/}
            {/*    onChange={(v) => handleInput(`region`, v)}*/}
            {/*    error={getFieldError(`region`)}*/}
            {/*/>*/}

            <Input
                onChange={(v) => handleInput(`password`, v)}
                value={form?.password ?? null}
                label="Please enter a password for this website – passwords should be 10 characters long and contain at least one number and one uppercase letter*"
                error={getFieldError(`password`)}
                type="password"
                labelColour={ 'text-app-blue' }
            />

            <Input
                onChange={(v) => handleInput(`password_confirmation`, v)}
                value={form?.password_confirmation ?? null}
                label="Confirm Password*"
                error={getFieldError(`password_confirmation`)}
                type="password"
                labelColour={ 'text-app-blue' }
            />
        </>
    );
};

export default RegistrationForm;
